import { registerSmarticoProfileEventHandler } from '~/handlers/register-smartico-profile-event';
import { NativeEvent } from '~/shared/NativeBridge/NativeEvent';
import { SmarticoProfileEvent } from '~/shared/smartico/smartico-profile-event';
import { useUserJourneyStore } from '~/stores/apostatudo/user-journey';

export const useSmarticoProfileEvent = () => {
  const journeyStore = useUserJourneyStore();
  const { userId } = useUserData();

  const sendLoginEvent = async (): Promise<void> => {
    if (!NativeEvent.isNativeApp()) return;

    const platform = journeyStore.appsflyer.platform;

    if (!platform) return;

    const userExtId = String(userId.value || '');

    if (!userExtId) return;

    try {
      await registerSmarticoProfileEventHandler({
        event: SmarticoProfileEvent.UpdateProfile,
        user_ext_id: userExtId,
        payload: { core_custom_prop25: platform.toUpperCase() },
      });
    } catch (e) {
      console.error('[smartico-profile-event] failed', e);
    }
  };

  return { sendLoginEvent };
};
